import { Grid } from "@mui/material";
import React from "react";
import { fixedDigitsAfterDecimal } from "../../../../utils";
import CustomizedProgressBars from "../../../board/components/progressBar/ProgressBar";

export const ByTaskDeskTopProgressBar = ({ card = [] }) => {
  return (
    <Grid item xs={12} md={3}>
      <div className="right-details">
        <div className="d-flex justify-content-end">
          <p className="worklog-status">{card[0]?.workflow_step_name}</p>
        </div>
        <div style={{ minWidth: "180px" }}>
          <CustomizedProgressBars
            allocatedHours={card[0]?.cardlog?.card?.allocated_hours}
            hoursSpent={fixedDigitsAfterDecimal(
              card.reduce(
                (sum, cardDetails) => sum + cardDetails?.cardlog?.hours_spent,
                0
              )
            )}
            hideDate={true}
          />
        </div>
      </div>
    </Grid>
  );
};
